import { Flex, Skeleton } from "@suns/design-system";
import bigBoards from "./big-board-ranks.json";
import { useAsync } from "@/shared/hooks";
import { viewPlayerLoader } from "./loaders/player-loader";
import { PlayerPrintPage } from "./components/PlayerPrintPage";

export function PlayersDraftBigBoardPrint() {
  return (
    <Flex direction="down" gap="lg" className="print:gap-0">
      {bigBoards.scoutBigBoard?.map((player) => (
        <PlayerPages key={player.playerId} playerId={player.playerId} />
      ))}
    </Flex>
  );
}

function PlayerPages({ playerId }: { playerId: number }) {
  const { response, loading } = useAsync(viewPlayerLoader, {
    playerId,
  });

  if (loading) {
    return <PagesLoading />;
  }

  if (!response?.player) {
    return null;
  }

  return (
    <Flex
      direction="right"
      gap="md"
      className="h-80 w-full print:h-auto print:flex-col print:gap-0"
    >
      <PlayerPrintPage
        player={response?.player}
        scores={response?.scores ?? []}
        direction="right"
        className="origin-top-left scale-[33%] print:scale-[100%]"
      />
    </Flex>
  );
}

function PagesLoading() {
  return (
    <Flex direction="down" gap="sm">
      <Flex direction="right" gap="sm" className="w-full">
        <Skeleton className="h-72 w-56" />
        <Skeleton className="h-72 w-56" />
        <Skeleton className="h-72 w-56" />
        <Skeleton className="h-72 w-56" />
      </Flex>
      <Flex direction="right" gap="sm" className="w-full">
        <Skeleton className="h-72 w-56" />
        <Skeleton className="h-72 w-56" />
        <Skeleton className="h-72 w-56" />
        <Skeleton className="h-72 w-56" />
      </Flex>
    </Flex>
  );
}
